import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSettings";

export type HandlerType = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, ParseInvoiceCreditCardData);
addToChainAfter(chain, ParseInvoiceCreditCardData, AddCheckoutSettings);
addToChainAfter(chain, AddCheckoutSettings, AddSystemSettings);

function ParseInvoiceCreditCardData(props: HandlerType) {
    const settingsModel = props.apiResult;

    if (props.apiResult.settingsCollection.productSettings) {
        const productSettings = props.apiResult.settingsCollection.productSettings;
        if (settingsModel.properties["documentIconsRootPath"]) {
            productSettings.documentIconsRootPath = settingsModel.properties["documentIconsRootPath"];
        }
        if (settingsModel.properties["showSavings"]) {
            productSettings.showSavings = settingsModel.properties["showSavings"].toString().toLowerCase() === "true";
        }
    }

    if (props.apiResult.settingsCollection.cartSettings) {
        const cartSettings = props.apiResult.settingsCollection.cartSettings;
        if (settingsModel.properties["addStoredCreditCardPaymentMethod"]) {
            cartSettings.addStoredCreditCardPaymentMethod =
                settingsModel.properties["addStoredCreditCardPaymentMethod"];
        }

        if (settingsModel.properties["storedCreditCardPaymentMethod"]) {
            cartSettings.storedCreditCardPaymentMethod = settingsModel.properties["storedCreditCardPaymentMethod"];
        }
    }
}

function AddCheckoutSettings(props: HandlerType) {
    const settingsModel = props.apiResult;

    if (props.apiResult.settingsCollection.orderSettings) {
        const orderSettings = props.apiResult.settingsCollection.orderSettings;
        if (settingsModel.properties["enableCollectAccounts"]) {
            orderSettings.enableCollectAccounts =
                settingsModel.properties["enableCollectAccounts"].toString().toLowerCase() === "true";
        }
    }
}

function AddSystemSettings(props: HandlerType) {
    const settingsModel = props.apiResult;

    const ausCountries: string[] = JSON.parse(settingsModel.properties["ausCountries"]);
    props.apiResult.settingsCollection.systemSettings = { ausCountries };
}
